<template>
  <div class="login">
    <div class="container">
      <!-- <img class="logo" src="./logo.png" alt="" /> -->
      <div class="login-form">
        <!-- <h1>用数据洞察世界</h1> -->
        <img src="./more.png" alt="" style="margin-left: -64px" />
        <div class="form-wrap" style="margin-top: 33px">
          <div class="titleHeader">
            <img
              src="./liehuxing.png"
              alt=""
              style="width: 42px; display: inline; margin-bottom: 12px"
            />
            <div
              style="
                display: inline;
                font-size: 28px;
                font-family: FZLanTingHei-L-GBK;
                font-weight: 400;
                color: #333333;
                line-height: 53px;
                margin-left: 18px;
              "
            >
              猎户星数据采集平台
            </div>
          </div>
          <div>
            <!-- <a-tabs
              default-active-key="account"
              :tab-position="tabPosition"
              @change="callback"
              class="tabsFormat"
            >
              <a-tab-pane key="account" tab="密码登录"> </a-tab-pane>
              <a-tab-pane key="verification" tab="验证码登录"> </a-tab-pane>
            </a-tabs> -->
          </div>
          <!-- <div class="login-type">
            <span @click="type = 'verification'" :class="type == 'verification' ? 'active' : ''"
              >验证码登录</span
            >

            <span @click="type = 'account'" :class="type == 'account' ? 'active' : ''">
              账号密码登录
            </span>
          </div> -->
          <a-form-model
            v-if="type == 'account'"
            :model="userform"
            :rules="userformRules"
            ref="userform"
            style="margin-top:18px"
          >
            <a-form-model-item prop="loginAccount">
              <a-input
                v-model="userform.loginAccount"
                size="large"
                placeholder="请输入手机号或邮箱"
              >
                <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="password">
              <a-input
                v-model="userform.password"
                size="large"
                type="password"
                placeholder="请输入登录密码"
              >
                <a-icon slot="prefix" type="lock" style="color: rgba(0, 0, 0, 0.25)" />
              </a-input>
            </a-form-model-item>

            <a-form-model-item>
              <a-button
                @click="handleSubmitUser"
                size="large"
                style="width: 100%"
                type="primary"
                html-type="submit"
              >
                登 录
              </a-button>
            </a-form-model-item>

            <!-- <div class="registe">
              <span>
                还没有账号？立即
                <a href="#/register">注册</a>
              </span>
            </div> -->
          </a-form-model>
          <a-form-model v-else :model="codeform" :rules="codeRules" ref="codeform">
            <a-form-model-item prop="loginAccount">
              <a-input
                v-model="codeform.loginAccount"
                size="large"
                placeholder="请输入手机号或邮箱"
              >
                <a-icon slot="prefix" type="user" style="color: rgba(0, 0, 0, 0.25)" />
              </a-input>
            </a-form-model-item>
            <a-form-model-item prop="verifyCode">
              <a-input
                v-model="codeform.verifyCode"
                size="large"
                :placeholder="verificationPlaceholder"
              >
                <a-button
                  type="link"
                  @click.stop="getVerifyCode"
                  :disabled="verificationDisabled"
                  slot="suffix"
                  ><a-divider type="vertical" /> <span>获取验证码</span>
                </a-button>
              </a-input>
            </a-form-model-item>

            <a-form-model-item>
              <a-button
                @click="handleSubmitCode"
                size="large"
                style="width: 100%"
                type="primary"
                html-type="submit"
              >
                登 录
              </a-button>
            </a-form-model-item>

            <div class="registe">
              <span>
                还没有账号？立即
                <a href="#/register">注册</a>
              </span>
            </div>
          </a-form-model>

          <a-form-model v-if="type != 'account'">
            <div class="service-contract">
              <div class="detail-info">
                <span> 未注册的手机号/邮箱登录后自动注册 </span>
              </div>

              <div class="contract-info">
                <span>
                  注册即代表同意
                  <a @click="handleContract">《服务协议》</a>
                </span>
              </div>
            </div>
          </a-form-model>
        </div>
      </div>
    </div>

    <a-modal
      width="800px"
      title="服务协议"
      :visible="contractVisible"
      :closable="false"
      @ok="handleOk"
    >
      <template slot="footer">
        <a-button key="submit" type="primary" @click="handleOk"> 确定 </a-button>
      </template>

      <div class="contract">
        <p>
          {{ contract }}
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {
  userNameLoginApi,
  getVerifyCodeApi,
  verificationLoginApi,
  userIsExistApi
} from '@/api/System/User'
import { contract } from '@/common/Login/Contract'
const phoneReg = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/
const emailReg = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/
import { setToken } from '@/utils/'
import { mapMutations } from 'vuex'
import { message } from 'ant-design-vue'
export default {
  data() {
    let validatePhoneMail = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入手机号或邮箱'))
      } else {
        if (phoneReg.test(value) || emailReg.test(value)) {
          callback()
        } else {
          callback(new Error('请输入正确的手机号或邮箱格式'))
        }
      }
    }

    return {
      userform: {
        loginAccount: null,
        password: null
      },
      userformRules: {
        loginAccount: [{ validator: validatePhoneMail, trigger: 'blur' }],
        password: [{ required: true, message: '密码不能为空', trigger: 'blur' }]
      },
      type: 'account',
      verificationPlaceholder: '请输入验证码',
      timer: null,
      count: '',
      verificationDisabled: false,
      codeform: {
        loginAccount: '',
        verifyCode: '',
        verifyCodeSourceType: ''
      },
      codeRules: {
        loginAccount: [{ validator: validatePhoneMail, trigger: 'blur' }],
        verifyCode: [{ required: true, message: '验证码不能为空', trigger: 'blur' }]
      },
      contractVisible: false,
      contract: contract,
      tabPosition: 'top'
    }
  },
  methods: {
    ...mapMutations(['SET_USER_INFO']),
    //获取验证码
    async getVerifyCode() {
      let { loginAccount } = this.codeform
      if (phoneReg.test(loginAccount) || emailReg.test(loginAccount)) {
        let type = ''
        if (phoneReg.test(loginAccount)) {
          type = 'sms'
          this.codeform.verifyCodeSourceType = 'sms'
        } else if (emailReg.test(loginAccount)) {
          type = 'mail'
          this.codeform.verifyCodeSourceType = 'mail'
        } else {
          type = ''
        }
        let res = await getVerifyCodeApi({ loginAccount: loginAccount, type })
        let { code, msg } = res
        if (code == 200) {
          this.getPhoneCode()
        } else {
          this.$message.error(msg)
        }
      } else {
        this.$message.error('请填写正确的手机号或邮箱')
      }
    },

    callback(key) {
      this.type = key
    },

    getPhoneCode() {
      let TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
            this.verificationPlaceholder = this.count + 's后重新获取验证码'
            this.verificationDisabled = true
          } else {
            clearInterval(this.timer)
            this.timer = null
            this.verificationPlaceholder = '请输入验证码'
            this.verificationDisabled = false
          }
        }, 1000)
      }
    },

    //账号密码登陆
    async userNameLogin() {
      let res = await userNameLoginApi({ ...this.userform })
      let { code, msg, extra } = res
      if (code == 200) {
        this.$message.success('登录成功')
        this.handleAfterLogin(extra.user)
      } else {
        this.$message.error(msg)
      }
    },

    //验证码登陆
    async verificationLogin() {
      let res = await verificationLoginApi({ ...this.codeform })
      let { code, msg, extra } = res
      if (code == 200) {
        this.$message.success('登录成功')
        this.handleAfterLogin(extra.user)
      } else {
        this.$message.error(msg)
      }
    },

    handleSubmitUser() {
      this.$refs['userform'].validate((valid) => {
        if (valid) {
          this.userNameLogin()
        } else {
          return false
        }
      })
    },

    handleAfterLogin(user) {
      let { token, secret } = user
      this.SET_USER_INFO(user)
      setToken(token, secret)
      this.$router.push({ path: '/home' })
    },

    handleContract() {
      this.contractVisible = true
    },
    handleOk() {
      this.contractVisible = false
    },
    handleSubmitCode() {
      this.$refs['codeform'].validate((valid) => {
        if (valid) {
          if (this.codeform.verifyCodeSourceType === '') {
            message.error('请获取验证码')
          } else {
            this.verificationLogin()
          }
        } else {
          return false
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.login {
  height: 100%;
  background: url('./login.png');
  background-size: 100%;
  position: relative;
  .container {
    // background: url('./bg-container.png');
    background-size: 100%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 1380px;
    height: 580px;
    .logo {
      position: absolute;
      left: 170px;
      top: -80px;
      width: 160px;
      height: 60px;
    }
    .login-form {
      width: 420px;
      box-shadow: 0px 6px 27px 0px rgba(0, 0, 0, 0.1);
      position: absolute;
      top: 10px;
      right: 33%;
      box-sizing: border-box;
      h1 {
        height: 55px;
        font-size: 40px;
        font-weight: 500;
        color: #fff;
        margin-bottom: 45px;
        text-align: center;
        letter-spacing: 2px;
      }
      .form-wrap {
        background: #ffffff;
        padding: 40px 40px 16px;
        border-radius: 6px;
        .registe {
          display: flex;
          justify-content: space-around;
          margin-bottom: 20px;
        }
        .login-type {
          display: flex;
          justify-content: space-between;
          margin-bottom: 24px;
          span {
            width: 160px;
            height: 46px;
            line-height: 46px;
            text-align: center;
            background: #fff;
            border: 1px solid #e2e2e2;
            border-radius: 4px;
            cursor: pointer;
            &.active {
              border: 1px solid #3c93ff;
            }
          }
        }
        .service-contract {
          font-size: 12px;
          color: #999999;
          line-height: 18px;
          text-align-last: center;
        }
      }
    }
  }
}

.contract {
  white-space: pre-line;
}
</style>

<style scoped>
.tabsFormat /deep/ .ant-tabs-nav-wrap {
  text-align: center;
  font-size: 16px;
}
/* .tabsFormat /deep/ .ant-tabs-nav .ant-tabs-tab-active {
  font-size: 16px;
} */
</style>
